export default "__VITE_ASSET__53836031__"